/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Contact_Admin_PermissionsInputs */

const en_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact your team admin or manager to change permissions.`)
};

const fr_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactez l’administrateur ou le manager de votre équipe pour modifier les autorisations.`)
};

const de_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenden Sie sich an Ihren Teamadministrator oder Manager, um die Berechtigungen zu ändern.`)
};

const it_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta l'amministratore o il responsabile del tuo team per modificare le autorizzazioni.`)
};

const ru_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для изменения прав доступа обратитесь к администратору или менеджеру вашей команды.`)
};

const es_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comuníquese con el administrador o gerente de su equipo para cambiar los permisos.`)
};

const zh_cn2_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请联系您的团队管理员或经理更改权限。`)
};

const ja_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`権限を変更するには、チーム管理者またはマネージャーに連絡してください。`)
};

const hi_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमतियों में बदलाव करने के लिए अपनी टीम के एडमिन या मैनेजर से संपर्क करें।`)
};

const pt_pt2_knp_guide_contact_admin_permissions = /** @type {(inputs: Knp_Guide_Contact_Admin_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para alterar as permissões, entre em contato com o administrador ou gerente da sua equipe.`)
};

/**
* | output |
* | --- |
* | "Contact your team admin or manager to change permissions." |
*
* @param {Knp_Guide_Contact_Admin_PermissionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_contact_admin_permissions = /** @type {((inputs?: Knp_Guide_Contact_Admin_PermissionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Contact_Admin_PermissionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_contact_admin_permissions(inputs)
	if (locale === "de") return de_knp_guide_contact_admin_permissions(inputs)
	if (locale === "it") return it_knp_guide_contact_admin_permissions(inputs)
	if (locale === "ru") return ru_knp_guide_contact_admin_permissions(inputs)
	if (locale === "es") return es_knp_guide_contact_admin_permissions(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_contact_admin_permissions(inputs)
	if (locale === "ja") return ja_knp_guide_contact_admin_permissions(inputs)
	if (locale === "hi") return hi_knp_guide_contact_admin_permissions(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_contact_admin_permissions(inputs)
	return en_knp_guide_contact_admin_permissions(inputs)
});